import { Component, type ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { Notice } from "./components/workbench";
export function message(cause: unknown) {
  const text =
    cause instanceof Error ? cause.message : "The action did not complete. Try again.";
  return text.match(/Uncaught Error: ([^\n]+)/)?.[1] ?? text;
}
// The internal app owns authentication, two-factor checks and the Convex provider.
export class CloudGate extends Component<
  { children: ReactNode },
  { error: string | null }
> {
  override state = { error: null as string | null };
  static getDerivedStateFromError(cause: unknown) {
    return { error: message(cause) };
  }
  override render() {
    return this.state.error ? (
      <Notice error title="Roastery unavailable">
        <p>{this.state.error}</p>
        <Button
          className="mt-3"
          variant="outline"
          onClick={() => this.setState({ error: null })}
        >
          Try again
        </Button>
      </Notice>
    ) : (
      this.props.children
    );
  }
}
